export default __webpack_public_path__ + "static/media/trafficlight.5e9ad71f.png";